

import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import {
  styled,
  Box,
  Chip as MuiChip,
  ListItemIcon as MuiListItemIcon,
  Typography,
} from '@mui/material';

export const MainContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'gapValue',
})<{ gapValue: string }>(({ theme, gapValue }) => ({
  display: 'flex',
  gap: gapValue,
  height: 'calc(100vh - 64px)',
  backgroundColor: theme.palette.paper.dark,
  overflow: 'hidden',
}));

export const SidebarOverlay = styled(OverlayScrollbarsComponent, {
  shouldForwardProp: (prop) => prop !== 'sidebarWidth',
})<{ sidebarWidth: number }>(({ theme, sidebarWidth }) => ({
  width: sidebarWidth,
  minWidth: sidebarWidth,
  maxWidth: sidebarWidth,
  backgroundColor: theme.palette.paper.dark,
  boxSizing: 'border-box',
  height: '100%',
  boxShadow: theme.shadows[1],
}));

export const Sidebar = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact: boolean }>(({ theme, isCompact }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: isCompact ? theme.spacing(2) : theme.spacing(3),
  paddingTop: isCompact ? theme.spacing(2) : theme.spacing(3),
  paddingBottom: isCompact ? theme.spacing(2) : theme.spacing(3),
  paddingLeft: isCompact ? theme.spacing(2) : theme.spacing(1.5),
  paddingRight: isCompact ? theme.spacing(2) : theme.spacing(1.5),
}));

export const Title = styled(Typography)({
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const Subtitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact: boolean }>(({ isCompact }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: isCompact ? 9 : 10,
  color: 'text.secondary'
}));

export const Amount = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact: boolean }>(({ isCompact }) => ({
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: isCompact ? '0.875rem' : '1rem'
}));

export const ListItemIcon = styled(MuiListItemIcon, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact: boolean }>(({ isCompact }) => ({
  color: 'inherit',
  minWidth: isCompact ? '32px' : '35px',
}));

export const ListItemTextPrimary = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const Chip = styled(MuiChip, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact: boolean }>(({ isCompact }) => ({
  fontSize: isCompact ? '0.65rem' : '0.75rem',
  height: isCompact ? 20 : 24,
  flexShrink: 0,
}));

export const HotelListBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minWidth: 0,
});

export const RightContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact: boolean }>(({ theme, isCompact }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: theme.spacing(isCompact ? 2 : 3),
  paddingTop: theme.spacing(isCompact ? 2 : 3),
  gap: isCompact ? theme.spacing(2) : theme.spacing(3),
}));

export const RightOverlay = styled(OverlayScrollbarsComponent, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact: boolean }>(({ theme, isCompact }) => ({
  minWidth: 300,
  width: '100%',
  backgroundColor: theme.palette.paper.dark,
  boxSizing: 'border-box',
  height: '100%',
  display: 'flex',
  flex: 1,
  paddingBottom: theme.spacing(2),
  paddingRight: theme.spacing(isCompact ? 4 : 8),
}));
